import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import AzRating from '~/components/_next/atoms/AzRating.vue';
import { gtmPushEvent } from '~/helpers/gtm';
import AzImg from '~/components/Atoms/AzImg.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default defineComponent({
  name: 'RecipeCard',
  components: {
    AzImg: AzImg,
    RecipesWishlistButton: function RecipesWishlistButton() {
      return import('~/components/RecipeWishlist/RecipesWishlistButton.vue');
    },
    AzRating: AzRating,
    NuxtLinkCustom: NuxtLinkCustom
  },
  props: {
    recipe: {
      type: Object,
      default: function _default() {}
    },
    isTargetBlank: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props) {
    var router = useRouter();
    var reviews = computed(function () {
      var _ref, _props$recipe$fields$, _props$recipe$fields, _props$recipe$fields$2, _props$recipe, _props$recipe$reviews;
      return (_ref = (_props$recipe$fields$ = (_props$recipe$fields = props.recipe.fields) === null || _props$recipe$fields === void 0 ? void 0 : (_props$recipe$fields$2 = _props$recipe$fields.reviewsRating) === null || _props$recipe$fields$2 === void 0 ? void 0 : _props$recipe$fields$2.count) !== null && _props$recipe$fields$ !== void 0 ? _props$recipe$fields$ : (_props$recipe = props.recipe) === null || _props$recipe === void 0 ? void 0 : (_props$recipe$reviews = _props$recipe.reviewsRating) === null || _props$recipe$reviews === void 0 ? void 0 : _props$recipe$reviews.count) !== null && _ref !== void 0 ? _ref : 0;
    });
    var rating = computed(function () {
      var _ref2, _props$recipe$fields$3, _props$recipe$fields2, _props$recipe$fields3, _props$recipe2, _props$recipe2$review;
      return (_ref2 = (_props$recipe$fields$3 = (_props$recipe$fields2 = props.recipe.fields) === null || _props$recipe$fields2 === void 0 ? void 0 : (_props$recipe$fields3 = _props$recipe$fields2.reviewsRating) === null || _props$recipe$fields3 === void 0 ? void 0 : _props$recipe$fields3.rate) !== null && _props$recipe$fields$3 !== void 0 ? _props$recipe$fields$3 : (_props$recipe2 = props.recipe) === null || _props$recipe2 === void 0 ? void 0 : (_props$recipe2$review = _props$recipe2.reviewsRating) === null || _props$recipe2$review === void 0 ? void 0 : _props$recipe2$review.rate) !== null && _ref2 !== void 0 ? _ref2 : 0;
    });
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      i18n = _useNuxt2App.i18n;
    var recipeTitle = computed(function () {
      var _ref3, _props$recipe$fields$4, _props$recipe3, _props$recipe3$fields, _props$recipe4;
      return (_ref3 = (_props$recipe$fields$4 = (_props$recipe3 = props.recipe) === null || _props$recipe3 === void 0 ? void 0 : (_props$recipe3$fields = _props$recipe3.fields) === null || _props$recipe3$fields === void 0 ? void 0 : _props$recipe3$fields.title) !== null && _props$recipe$fields$4 !== void 0 ? _props$recipe$fields$4 : (_props$recipe4 = props.recipe) === null || _props$recipe4 === void 0 ? void 0 : _props$recipe4.title) !== null && _ref3 !== void 0 ? _ref3 : '';
    });
    var recipeId = computed(function () {
      var _props$recipe$sys$id, _props$recipe5, _props$recipe5$sys, _props$recipe6;
      return (_props$recipe$sys$id = (_props$recipe5 = props.recipe) === null || _props$recipe5 === void 0 ? void 0 : (_props$recipe5$sys = _props$recipe5.sys) === null || _props$recipe5$sys === void 0 ? void 0 : _props$recipe5$sys.id) !== null && _props$recipe$sys$id !== void 0 ? _props$recipe$sys$id : (_props$recipe6 = props.recipe) === null || _props$recipe6 === void 0 ? void 0 : _props$recipe6.id;
    });

    // Get the first carousel item as a main recipe image
    var mainImageURL = computed(function () {
      var _ref4, _props$recipe$fields$5, _props$recipe7, _props$recipe7$fields, _props$recipe7$fields2, _props$recipe7$fields3, _props$recipe8;
      return (_ref4 = (_props$recipe$fields$5 = (_props$recipe7 = props.recipe) === null || _props$recipe7 === void 0 ? void 0 : (_props$recipe7$fields = _props$recipe7.fields) === null || _props$recipe7$fields === void 0 ? void 0 : (_props$recipe7$fields2 = _props$recipe7$fields.carousel[0].fields) === null || _props$recipe7$fields2 === void 0 ? void 0 : (_props$recipe7$fields3 = _props$recipe7$fields2.file) === null || _props$recipe7$fields3 === void 0 ? void 0 : _props$recipe7$fields3.url) !== null && _props$recipe$fields$5 !== void 0 ? _props$recipe$fields$5 : (_props$recipe8 = props.recipe) === null || _props$recipe8 === void 0 ? void 0 : _props$recipe8.coverImageUrl) !== null && _ref4 !== void 0 ? _ref4 : '';
    });
    // Get parent of the first item in "recipe family" as a main attribute

    var mainAttribute = computed(function () {
      var _props$recipe9, _props$recipe9$fields, _props$recipe0, _props$recipe10, _props$recipe10$field, _props$recipe10$field2, _props$recipe10$field3, _props$recipe10$field4, _props$recipe10$field5, _props$recipe10$field6;
      var attraqtCategory = props === null || props === void 0 ? void 0 : (_props$recipe9 = props.recipe) === null || _props$recipe9 === void 0 ? void 0 : (_props$recipe9$fields = _props$recipe9.fields) === null || _props$recipe9$fields === void 0 ? void 0 : _props$recipe9$fields.category;
      if (attraqtCategory) return attraqtCategory;
      if ((_props$recipe0 = props.recipe) !== null && _props$recipe0 !== void 0 && _props$recipe0.parentFamilyName) {
        var _props$recipe1;
        return (_props$recipe1 = props.recipe) === null || _props$recipe1 === void 0 ? void 0 : _props$recipe1.parentFamilyName;
      }
      var translationKey = (_props$recipe10 = props.recipe) === null || _props$recipe10 === void 0 ? void 0 : (_props$recipe10$field = _props$recipe10.fields) === null || _props$recipe10$field === void 0 ? void 0 : (_props$recipe10$field2 = _props$recipe10$field.cosmecticRecipeFamily) === null || _props$recipe10$field2 === void 0 ? void 0 : (_props$recipe10$field3 = _props$recipe10$field2[0]) === null || _props$recipe10$field3 === void 0 ? void 0 : (_props$recipe10$field4 = _props$recipe10$field3.fields) === null || _props$recipe10$field4 === void 0 ? void 0 : (_props$recipe10$field5 = _props$recipe10$field4.parentFamily) === null || _props$recipe10$field5 === void 0 ? void 0 : (_props$recipe10$field6 = _props$recipe10$field5.toLowerCase()) === null || _props$recipe10$field6 === void 0 ? void 0 : _props$recipe10$field6.replace(/\s/g, '');
      return translationKey ? i18n.t("rdp.recipeFamily.".concat(translationKey)) : null;
    });
    var recipeBaseLink = computed(function () {
      var _props$recipe11, _props$recipe11$sys, _props$recipe11$sys$c, _props$recipe11$sys$c2, _props$recipe12;
      var contentTypeName = ((_props$recipe11 = props.recipe) === null || _props$recipe11 === void 0 ? void 0 : (_props$recipe11$sys = _props$recipe11.sys) === null || _props$recipe11$sys === void 0 ? void 0 : (_props$recipe11$sys$c = _props$recipe11$sys.contentType) === null || _props$recipe11$sys$c === void 0 ? void 0 : (_props$recipe11$sys$c2 = _props$recipe11$sys$c.sys) === null || _props$recipe11$sys$c2 === void 0 ? void 0 : _props$recipe11$sys$c2.id) || ((_props$recipe12 = props.recipe) === null || _props$recipe12 === void 0 ? void 0 : _props$recipe12.__typename);
      if (contentTypeName === undefined) {
        return '';
      }
      return 'legacy-Recipe-slug';
    });
    var recipeSlug = computed(function () {
      var _ref5, _props$recipe$fields$6, _props$recipe13, _props$recipe13$field, _props$recipe14;
      return (_ref5 = (_props$recipe$fields$6 = (_props$recipe13 = props.recipe) === null || _props$recipe13 === void 0 ? void 0 : (_props$recipe13$field = _props$recipe13.fields) === null || _props$recipe13$field === void 0 ? void 0 : _props$recipe13$field.slug) !== null && _props$recipe$fields$6 !== void 0 ? _props$recipe$fields$6 : (_props$recipe14 = props.recipe) === null || _props$recipe14 === void 0 ? void 0 : _props$recipe14.slug) !== null && _ref5 !== void 0 ? _ref5 : '';
    });
    var isRecipeHasSlug = computed(function () {
      return Boolean(recipeSlug.value);
    });
    var recipeLink = computed(function () {
      return app.localePath({
        name: recipeBaseLink.value,
        params: {
          slug: recipeSlug.value
        }
      });
    });
    var recipeLinkGoReviews = function recipeLinkGoReviews() {
      router.push(app.localePath({
        name: recipeBaseLink.value,
        params: {
          slug: recipeSlug.value
        },
        hash: '#rating-reviews'
      }));
    };
    var gtmRecipeClick = function gtmRecipeClick(title) {
      var eventData = [{
        event: 'generic_event',
        event_category: 'engagement',
        event_action: 'click',
        event_label: 'recipe',
        event_name: 'generic_event',
        recipe: title
      }];
      gtmPushEvent('recipe', eventData);
    };
    return {
      recipeLinkGoReviews: recipeLinkGoReviews,
      gtmRecipeClick: gtmRecipeClick,
      mainImageURL: mainImageURL,
      mainAttribute: mainAttribute,
      recipeId: recipeId,
      recipeLink: recipeLink,
      isRecipeHasSlug: isRecipeHasSlug,
      reviews: reviews,
      rating: rating,
      recipeTitle: recipeTitle
    };
  }
});